<template>
  <div class="maint-wrap">
    <!-- 배경이미지 컨테이너(PC/모바일 자동 전환) -->
    <div class="maint-art" :class="{ mobile: isMobile }">
      <!-- PC 전용 QR 핫스팟 (모바일은 전체가 링크라 숨김) -->
      <a
        v-if="!isMobile"
        class="hotspot"
        :href="link"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="진료예약으로 이동"
      />
      <!-- 모바일 전체 클릭 -->
      <a
        v-else
        class="mobile-cover"
        :href="link"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="진료예약으로 이동"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "SystemCheckView",
  data() {
    return {
      isMobile: false,
      link: "https://va.exona.ai/0286775cc3ff44a2bff37592cd8a0fb7",
    };
  },
  mounted() {
    const mq = window.matchMedia("(max-width: 768px)");
    this.isMobile = mq.matches;
    mq.addEventListener?.("change", e => (this.isMobile = e.matches));
  },
};
</script>

<style scoped>
/* 화면 꽉 채우고 스크롤/여백 제거 */
.maint-wrap{
  position: fixed;
  inset: 0;
  overflow: hidden;
}

/* 컨테이너 자체를 전체 화면로 → 파란 여백 사라짐 */
.maint-art{
  position: relative;
  width: 100vw;
  height: 100vh;
  background: #fff center / contain no-repeat
              url("@/assets/resource/img/system-check-pc.png"); /* 기본 PC */
}

/* 모바일은 모바일 이미지를 배경으로 */
.maint-art.mobile{
  background-image: url("@/assets/resource/img/system-check-mobile.png");
}

/* PC 핫스팟: QR 코드 위치를 덮는 투명 링크 */
/* 아래 좌표/크기는 퍼센트로, 필요시 미세조정 */
.hotspot{
  position: absolute;
  z-index: 2;
  /* 대략 중앙 하단의 QR 위치(1920x1080 기준) */
  left: 50%;
  top: 71%;
  width: 6.2%;
  height: 11%;
  transform: translate(-50%, -50%);
  /* 개발 중 위치 확인용: 필요 시 켜고 조정 후 주석 처리 */
  /* outline: 2px dashed rgba(0,0,0,.2); */
}

/* 모바일은 전체 영역 클릭 */
.mobile-cover{
  position: absolute;
  inset: 0;
  z-index: 2;
  /* outline: 2px solid red; */
}
</style>
